import apiClient from 'api/apiClient';
import { User } from 'model/User';

export const getUserByUserId = async (userId: string): Promise<User[]> => {
  const response = await apiClient.get(`/v1/users/${userId}`);
  return response.data;
};
